<template>
  <ResultItem v-bind="forwarded" align-center>
    <ResultItemIcon :icon="mapIcon.location" />
    <ResultItemContent>
      <ResultItemText>{{ address.formatted }}</ResultItemText>
    </ResultItemContent>
  </ResultItem>
</template>

<script setup lang="ts">
import { useForwardPropsEmits } from "radix-vue";
import type { ResultItemProps, ResultItemEmits } from "~/components/shared/result-item/types";
import type { Database } from "@asap/shared/types/supabase.gen";

type AddressTableInsert = Database["public"]["Tables"]["address_table"]["Insert"];

type Props = ResultItemProps & { address: AddressTableInsert };

const props = defineProps<Props>();
const emits = defineEmits<ResultItemEmits>();
const forwarded = useForwardPropsEmits(props, emits);
</script>
